import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    button: {
        color: '#fff',
    },
});

export default useStyles;
